module.exports = __webpack_public_path__ + "img/box03_01.8d531fff.jpg";